import { render, staticRenderFns } from "./search-inbox-contact-requests.vue?vue&type=template&id=dfa26462&scoped=true&"
import script from "./search-inbox-contact-requests.vue?vue&type=script&lang=js&"
export * from "./search-inbox-contact-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa26462",
  null
  
)

export default component.exports